import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme<{ isAdmin: boolean }> = ({ theme, isAdmin }) => ({
    position: 'relative',
    flex: 'auto',

    overflow: 'auto',

    display: 'flex',
    flexDirection: 'column',

    height: '100%',

    // Admins get the white split-layout pane from MainSection; non-admins sit on the app background,
    // so the page paints its own card. The bounded height gives the virtualized list its size.
    extend: {
        condition: !isAdmin,
        style: {
            backgroundColor: theme.colors.backgroundsSecondary,

            min1024: {
                width: '100%',
                maxWidth: '39.8125rem',
                height: 'calc(100% - 1.5rem)',

                marginTop: '1.5rem',
                marginLeft: '1.5rem',

                borderRadius: '0.25rem',
            },
        },
    },
});

export const listContainer: TRuleWithTheme = ({ theme }) => ({
    flex: 1,

    display: 'flex',

    borderTopColor: theme.colors.lightGrey,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
});
